import { render, staticRenderFns } from "./apay.vue?vue&type=template&id=ff6b28e2&"
import script from "./apay.vue?vue&type=script&lang=js&"
export * from "./apay.vue?vue&type=script&lang=js&"
import style0 from "./apay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports